/**
 * Legacy bucketplace/ui에서 필요한 것들만 따로 옮겨두었습니다.
 * 새로만든 Sticky를 기획전에 적용할 수 있으면 제거하면 됩니다.
 */

import { createContext } from 'use-context-selector';

import { StickyDirection, StickyOptions, StickyState } from '../../types';

// These values are needed to determine the 'accumulatedOffset' of the
// sibling states.
export type StickyValueEntryState =
  Pick<StickyState,
  'disabled' | 'emulatedDisabled' | 'height' | 'bottom' | 'beginY'>;

export interface StickyValueEntry extends StickyValueEntryState {
  id: string;
  type: string | undefined;
  shouldInfluenceScroll: boolean;
  direction: StickyDirection | null;
  offset: number;
  offsetRange?: [number, number];
  disableBottom?: boolean;
  accumulatedOffset: number;
  accumulatedOffsetRange: [number, number];
  ref: React.RefObject<HTMLElement | null>;
  order: number;
}

export interface StickyValueContextValue {
  entries: Record<string, StickyValueEntry>;
}

export interface StickyControlContextValue {
  register(): string;
  update(
    id: string,
    containerRef: React.RefObject<HTMLElement | null>,
    options: StickyOptions,
    state: StickyState,
  ): void;
  unregister(id: string): void;
  getState(): StickyValueContextValue;
}

export const StickyValueContext =
  createContext<StickyValueContextValue | null>(null);
export const StickyControlContext =
  createContext<StickyControlContextValue | null>(null);
